import HostingMaintenance from "../components/HostingMaintenance";
import PageHeader from "../components/layout/PageHeader";
import { TID } from "../lib/testIds";
import { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function SystemPage() {
  const [status, setStatus] = useState(null);
  useEffect(() => {
    api.get("/system/status").then((r) => setStatus(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid={TID.system.root}>
      <PageHeader
        eyebrow="Diagnóstico"
        title="Hosting y mantenimiento"
        description="Revisa tu VPS y controla la limpieza de forma sencilla."
      />
      <HostingMaintenance />
      <details><summary className="mb-4 cursor-pointer text-sm text-zinc-400">Diagnóstico de la aplicación</summary>
      <div className="rounded-md border border-zinc-800 bg-zinc-950 p-6">
        <pre className="font-mono text-xs text-zinc-300 whitespace-pre-wrap break-words">
{status ? JSON.stringify(status, null, 2) : "Cargando…"}
        </pre>
      </div></details>
    </div>
  );
}
